<template>
  <div class="ml-1">
    <Button title="Панель" data-testId="control_buttons_panel" :icon="componentPanelIcon" @click="onClickPanelButton"
      :disabled="!store.getters.editMode" />
    <Button :disabled="store.getters.editMode" title="Лог выполнения скрипта" data-testId="control_buttons_log"
      class="ml-2" icon="pi pi-book" @click="onScriptLog" />
    <ToggleButton v-model="isEditMode" onLabel="Выйти" offLabel="Редактор" data-testId="control_buttons_editor"
      onIcon="pi pi-times" class="ml-2" offIcon="pi pi-box" :disabled="!scriptId || !store.getters.info.isAdmin"
      @change="onEditMoveable" />
    <Button v-show="store.getters.editMode" class="p-button-succes ml-2" @click="onSaveFacility">
      <i class="pi pi-save edit-button-icon"></i>
      <span class="ml-1 edit-button-text">Сохранить</span>
    </Button>
    <Button title="Редактировать" class="p-button-succes ml-2" @click="onClickEditFacility"
      data-testId="control_buttons_edit">
      <i class="pi pi-wrench edit-button-icon"></i>
      <span class="ml-1 edit-button-text">Редактировать</span>
    </Button>
    <component v-for="(control, i) of controls" :is="control?.component ? control.component : 'Button'"
      :loading="loading" :key="control.key" class="ml-2"
      @click="control.click ? confirmClickButton(control) : () => { }"
      @change="control.change ? control.change() : () => { }" v-model="controlsValue[control.key]"
      :disabled="store.getters.editMode || !store.getters.info.isControl"
      v-bind="{ ...control?.attrList, ...controlsAttrList[i] }" :title="control.name">
      <img v-if="control.index" :alt="control.name" :src="`images/24x24/${control.index}.png`" width="16" />
      <span class="ml-1 control-button-text">{{ control.name }}</span>
    </component>
  </div>

  <Dialog v-model:visible="isConfirmDialog" :style="{ width: '550px' }" modal>
    <template #header>
      <i class="pi pi-question-circle mr-3" style="font-size: 2rem; color: rgb(204,204,0)" />
      <div class="col-10 font-bold text-center" style="font-size: 1.3rem">
        Подтверждение
      </div>
    </template>

    <div class="confirmation-content">
      <div class="text-center">
        <span :style="{ 'font-size': '1.1rem' }">
          Подтверждение действия "{{ currentControl?.name }}"?
        </span>
      </div>
    </div>
    <template #footer>
      <Button label="Нет" icon="pi pi-times" class="p-button-text" @click="isConfirmDialog = false" />
      <Button label="Да" icon="pi pi-check" class="p-button-text" @click="onClickComponent" />
    </template>
  </Dialog>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onBeforeUnmount, defineProps, defineExpose } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import EventBus from '@/core/EventBus';

const props = defineProps({
  controls: {
    type: Array,
    default: () => [],
  },
  scriptId: {
    default: null,
  },
});

const store = useStore();
const route = useRoute();
const router = useRouter();

const isComponentPanel = ref(false);
const isEditMode = ref(store.getters.editMode);
const isConfirmDialog = ref(false);
const currentControl = ref(null);
const controlsValue = reactive({});
const controlsAttrList = ref([]);
const loading = ref(false);

const componentPanelIcon = computed(() =>
  `pi ${store.getters.showComponentPanel ? 'pi-angle-double-up' : 'pi-angle-double-down'}`
);

defineExpose({
  controlsValue
});

watch(
  () => store.getters.editMode,
  (newVal) => {
    isEditMode.value = newVal;
  },
  { immediate: true }
);

const onClickComponent = () => {
  const funct = currentControl.value?.click?.();
  if (isPromise(funct)) {
    loading.value = true;
    funct.finally(() => {
      loading.value = false;
    });
  }
  isConfirmDialog.value = false;
};

const isPromise = (promise) => {
  return promise instanceof Promise || (Boolean(promise) && typeof promise.then === 'function');
};

const confirmClickButton = (control) => {
  currentControl.value = control;
  isConfirmDialog.value = true;
};

const onEditMoveable = () => {
  EventBus.emit('on-edit-moveable');
};

const onClickPanelButton = () => {
  store.commit(
    'SET_SHOW_COMPONENT_PANEL',
    !store.getters.showComponentPanel
  );
};

const onSaveFacility = () => {
  EventBus.emit('on-save-facility');
};

const onClickEditFacility = () => {
  const routeResolved = router.resolve({
    name: 'facility',
  });
  window.open(
    `${routeResolved.href}?facility_id=${route.params.facility_id}`,
    '_blank'
  );
};

const onScriptLog = () => {
  EventBus.emit('on-change-script-log');
};

onMounted(() => {
  store.commit('SET_SHOW_COMPONENT_PANEL', false);
  isComponentPanel.value = store.getters.editMode;
  EventBus.on('on-set-control-buttons', (attrList) => {
    controlsAttrList.value = attrList;
  });
});

onBeforeUnmount(() => {
  EventBus.off('on-set-control-buttons');
});
</script>

<style scoped lang="scss">
@media screen and (max-width: 678px) {
  .control-button-text {
    display: none;
  }
}

@media screen and (max-width: 484px) {
  .edit-button-text {
    display: none;
  }

  .edit-button-icon {
    font-size: 1.12rem;
  }
}

@media screen and (max-width: 361px) {
  ::v-deep(.p-button.p-togglebutton.p-component) {
    .p-button-label {
      display: none;
    }

    .p-button-icon-left {
      margin-right: 0rem;
      font-size: 1.12rem;
    }
  }
}
</style>